export enum LeaveStatusEn {
  MORNING = 1,
  AFTERNOON = 2,
  FULL_DAY = 3
}

export const LeaveStatusValueEn = {
  MORNING: 0.5,
  AFTERNOON: 0.5,
  FULL_DAY: 1,
  HALF_DAY: 0.5
};

export const leaveStatusValues = [
  LeaveStatusValueEn.MORNING,
  LeaveStatusValueEn.AFTERNOON,
  LeaveStatusValueEn.FULL_DAY
];
